import { BiSolidToggleLeft, BiSolidToggleRight } from "react-icons/bi";

const Toggle = ({ label, checked, onChange }) => (
  <label className="flex items-center gap-2 text-sm font-medium text-gray-900 dark:text-gray-300">
    {checked ? (
      <BiSolidToggleRight className="text-blue-600 text-[40px] cursor-pointer" onClick={onChange} />
    ) : (
      <BiSolidToggleLeft className="text-gray-200 text-[40px] cursor-pointer" onClick={onChange} />
    )}
    <span>{label}</span>
  </label>
);

export default function QuestionToggles({ question, onUpdate }) {
  return (
    <div className="border-t pt-3 flex items-center justify-between gap-8">
      <div className="text-base font-normal text-gray-900 dark:text-gray-300 flex items-center gap-2">
        <span>Answer Type:</span>
        <div className="flex items-center gap-2 px-3 py-2 border border-gray-900 rounded-full text-sm font-medium bg-white dark:bg-gray-700 dark:text-white">
          {question.icon}
          {question.select}
        </div>
      </div>

      <div className="flex flex-wrap gap-4">
        {["Multiple Choice", "Checkboxes"].includes(question.select) && (
          <Toggle
            label="Add Notes"
            checked={question.hasNotes}
            onChange={() => onUpdate(question.id, { hasNotes: !question.hasNotes })}
          />
        )}

        {question.select === "Paragraph" && (
          <Toggle
            label="Paragraph Answer"
            checked={question.isParagraphAnswer}
            onChange={() =>
              onUpdate(question.id, {
                isParagraphAnswer: !question.isParagraphAnswer,
                isListMode: false,
                value: "",
                options: [],
              })
            }
          />
        )}

        {question.select === "Short Answer" && (
          <Toggle
            label="Input placeholder"
            checked={question.showPlaceholder}
            onChange={() => onUpdate(question.id, { showPlaceholder: !question.showPlaceholder })}
          />
        )}

        {!["Section Title", "Section Subtitle"].includes(question.select) &&
          !(question.select === "Paragraph" && !question.isParagraphAnswer) && (
            <Toggle
              label="Required?"
              checked={question.required}
              onChange={() => onUpdate(question.id, { required: !question.required })}
            />
          )}
      </div>
    </div>
  );
}
